import React, {useContext} from "react";
import OwButton from "../../../shared/OwButton/OwButton";
import UserTypesEnum from "../../../../models/UserTypesEnum";
import OwPrintButton from "../../../shared/OwPrintButton/OwPrintButton";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import {Link} from "react-router-dom";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import IPacking_List from "../../../../models/IPacking_List";
import UserContext from "../../../../contexts/UserContext";
import {IOption} from "../../../../models/IOption";
import {OwSelectOptionFn} from "../../../shared/OwSelectOptionFn/OwSelectOptionFn";
import {VerticalLine} from "../../../shared/VerticalLine/VerticalLine";
import {ControlBar} from "../../../shared/ControlBar/ControlBar";

type Props = {
    packingList: IPacking_List;
    savePackingList: () => void;
    updatePackingListLock: (isLocked: boolean) => void;
    isSaveActive: boolean;
    isFinalizeActive: boolean;
    hasUnsavedChanges: boolean;
    showShipmentSidebar: () => void;
    selectPageSize: (pageSize: any) => void;
    packingListTemplates: IOption[];
    copyPickedQtyToShipQty: () => void;
};

export const PackingListDetailHeader = (props: Props) => {
    const userModel = useContext(UserContext);

    let isNotLocalDeliveryOrPickup = true;
    let isLocalDelivery = false;
    let isLocalPickup = false;

    if (props.packingList.Orders) {
        for (const order of props.packingList.Orders) {
            if (order.is_local_pickup || order.is_local_delivery) {
                isNotLocalDeliveryOrPickup = false;
            }
        }

        if (props.packingList.Orders?.length === 1) {
            const order = props.packingList.Orders[0];

            if (order.is_local_delivery) {
                isLocalDelivery = true;
            }

            if (order.is_local_pickup) {
                isLocalPickup = true;
            }
        }
    }

    const leftElements: any[] = [];

    const notLockedElements = (!props.packingList.is_locked ? <div className={""}>
        <OwButton leftIconClass={"fad fa-copy"} title={"copy_pick_qty_to_ship_qty"} fn={props.copyPickedQtyToShipQty} className={"btn-primary d-print-none me-2"} />
        <OwButton
            leftIconClass={"fad fa-save"}
            className={"btn-primary d-print-none me-2"}
            title={"save"}
            fn={props.savePackingList}
            active={props.isSaveActive}
            disableOnActive={true}
        />
        <OwButton
            className={"btn-danger d-print-none"}
            leftIconClass={"fad fa-lock"}
            title={"finalize"}
            fn={() => {
                props.updatePackingListLock(true);
            }}
            active={props.isFinalizeActive}
            disableOnActive={true}
            disabled={props.hasUnsavedChanges}
        />
    </div> : null);

    if (notLockedElements) {
        leftElements.push(notLockedElements);
    }

    const lockedElements = (props.packingList.is_locked && userModel?.userType?.id === UserTypesEnum.ADMIN ? <OwButton
        className={"btn-danger d-print-none"}
        leftIconClass={"fad fa-unlock"}
        title={"unlock"}
        fn={() => {
            props.updatePackingListLock(false);
        }}
        active={props.isFinalizeActive}
        disableOnActive={true}
        disabled={props.hasUnsavedChanges}
    /> : null);

    if (lockedElements) {
        leftElements.push(lockedElements);
    }

    const pageSizeElement = (<OwSelectOptionFn
        valueProp={"value"}
        titleProp={"label"}
        fn={props.selectPageSize}
        name={"pageSize"}
        options={props.packingListTemplates}
        emitObject={true}
        selectedOption={props}
        selectedOptionProp={"pageSize"}
    />);

    const printBtn = <OwPrintButton/>;

    const centerElements: any[] = [pageSizeElement, printBtn];

    const createShipmentBtn = (props.packingList &&
    props.packingList.is_locked &&
    !props.packingList.shipment_id &&
    isNotLocalDeliveryOrPickup ? (
        <OwButton leftIconClass={"fad fa-truck"} title={"create_shipment"} fn={props.showShipmentSidebar} />
    ) : null);

    const viewShipmentBtn = (props.packingList && props.packingList.shipment_id ? (
        <div>
            <Link to={`/shipments?has_shipments=true&hide_signed=true&offset=0&limit=5&shipment_type=shipment&packing_list=${props.packingList.name}`}>
                <div className={"pointer btn btn-sm btn-primary"} >
                    <i className={"fas fa-truck me-2 pointer"}></i>
                    <OwLabel className={"pointer"} title={"view_shipment"} />
                </div>
            </Link>
        </div>
    ) : null);

    const rightElements: any[] = [];

    if (createShipmentBtn) {
        rightElements.push(createShipmentBtn);
    }

    if (viewShipmentBtn) {
        rightElements.push(viewShipmentBtn);
    }

    return <div className={"PackingListDetailHeader"}>
        <div className="row mt-2">
            <div className={"col-12 text-end "}>
                <ControlBar sections={[{name: "left", elements: leftElements}, {name: "center", elements: centerElements}, {name: "right", elements: rightElements}]}/>
            </div>
        </div>

        {props.hasUnsavedChanges ? (
            <div className={"text-end d-print-none"}>
                <OwLabel title={"pending_changes_save_first"} className={"text-danger"} />
            </div>
        ) : null}
    </div>;
};
